import React, { useState, useMemo } from "react";
import "./mobile.css"; // Assuming this is the name of your CSS file


// ... (utility functions getQueryParam and last3) ...
function getQueryParam(name) {
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
  } catch {
    return null;
  }
}

function last3() {
  const mac = getQueryParam("mac") || getQueryParam("tag") || "";

  if (mac.length >= 3) return mac.slice(-3).toLowerCase();
  if (mac.length > 0) return mac.toLowerCase();
  return "***";
}

function MobileLoginAndMFA({
  email,
  password,
  setEmail,
  setPassword,
  handleSubmit,
}) {
  const [localError, setLocalError] = useState(""); // Local state for immediate validation error
  const last = useMemo(() => last3(), []);

  const handleLocalSubmit = (e) => {
    e.preventDefault();
    setLocalError("");

    if (!email || !password) {
      setLocalError("Please enter both username and password.");
      return;
    }

    handleSubmit(e);
  };

  return (
    <div className="login-container">
      <div className="top-content-wrapper">
        <div className="white-splash-logo">
          <img src="https://storage.googleapis.com/content_ai_bucket_elhitech/content/truink%20splash%20-%20cropped.png" alt="TruInk Splash" />
        </div>
       <div>
         <p className="title-mobile">Welcome to Truink Tap</p>

        <p className="tagline">You have tapped ******{last}.</p>

        <p className="instruction-text">
          Login to enter the world of smart sustainability
        </p>

       </div>
        <form onSubmit={handleLocalSubmit} className="login-form">
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input-field"
            placeholder="Username"
          />

          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="input-field"
            placeholder="Password"
          />

          {localError && <p className="error-message">{localError}</p>}

          <button
            type="submit"
            className="login-button" // This button will now render correctly
          >
            Login
          </button>
        </form>
      </div>

      <p className="footer-text-login">v1.2.0 • Powered by ElhiTech</p>
    </div>
  );
}

export default MobileLoginAndMFA;
